module.exports = __webpack_public_path__ + "img/second_zhCn.2e7f804d.png";